import React from "react";
import { useSite } from "../context/SiteContext";

export default function Marquee() {
  const { c } = useSite();
  const { brand } = c;
  const text = `Clan Huchthausen · ${brand.motto} ·`;
  return (
    <div className="bg-oxblood py-6 overflow-hidden border-y border-[var(--c-border)]">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="font-display text-2xl sm:text-3xl italic text-parchment/90 px-6">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
